import React from "react";
import { formatMoney } from "accounting-js";
import { connect } from "react-redux";
import {
  setCcBw,
  setCcColour,
  setScanCharge,
  setFlatMonthlyCharge,
  setPerA3Charge,
  setMinimumMonthlyCharge,
  setTonerDeliveryCharge,
  setNzScanningMonthlyCharge,
} from "../redux/actions";
import style from "./Charges.module.css";
import { OnBlurInput } from "./OnBlurInput";
import { CC_BW_DISCOUNT, CC_COLOR_DISCOUNT, IS_NZ } from "../constants";
import { Form, FormControl, InputGroup, Table } from "react-bootstrap";
import { isPPPOrPMP } from "../redux/selectors";

function Charges(props) {
  return (
    <div className="form-group">
      <Form.Label>Click Charge</Form.Label>

      <Table variant="sm" className={style.table}>
        <thead>
          <tr>
            <th className={style.colHead} />
            <th className={style.colMinPrice}>Minimum Sell Price</th>
            <th className={style.colTargetPrice}>Target price</th>
          </tr>
        </thead>
        <tbody>
          {props.defaultCcBw ? (
            <tr>
              <th>Black &amp; White</th>
              <td>{props.defaultCcBw}¢</td>
              <td>
                <InputGroup>
                  <FormControl
                    as={OnBlurInput}
                    type="number"
                    value={props.ccBw}
                    onConfirm={e => props.setCcBw(e.target.value)}
                    min={
                      props.hasFallbackCcBw
                        ? props.defaultCcBw
                        : props.defaultCcBw * CC_BW_DISCOUNT
                    }
                    required
                  />
                  <InputGroup.Append>
                    <InputGroup.Text>¢</InputGroup.Text>
                  </InputGroup.Append>
                </InputGroup>
              </td>
            </tr>
          ) : null}

          {props.defaultCcColour ? (
            <tr>
              <th>Colour</th>
              <td>{props.defaultCcColour}¢</td>
              <td>
                <InputGroup>
                  <FormControl
                    as={OnBlurInput}
                    type="number"
                    value={props.ccColour}
                    onConfirm={e => props.setCcColour(e.target.value)}
                    min={
                      props.hasFallbackCcColour
                        ? props.defaultCcColour
                        : props.defaultCcColour * CC_COLOR_DISCOUNT
                    }
                    required
                  />
                  <InputGroup.Append>
                    <InputGroup.Text>¢</InputGroup.Text>
                  </InputGroup.Append>
                </InputGroup>
              </td>
            </tr>
          ) : null}

          {props.defaultScanCharge ? (
            <tr>
              <th>Scan Charge</th>
              <td>{props.defaultScanCharge}¢</td>
              <td>
                <InputGroup>
                  <FormControl
                    as={OnBlurInput}
                    type="number"
                    value={props.scanCharge}
                    onConfirm={e => props.setScanCharge(e.target.value)}
                    min={props.defaultScanCharge}
                  />
                  <InputGroup.Append>
                    <InputGroup.Text>¢</InputGroup.Text>
                  </InputGroup.Append>
                </InputGroup>
              </td>
            </tr>
          ) : null}

        </tbody>
      </Table>
      {props.flatMonthlyChargeModifiable ||
      (IS_NZ &&
        props.minimumMonthlyChargeModifiable &&
        props.defaultMinimumMonthlyCharge) ||
      (IS_NZ && props.defaultNzScanningMonthlyCharge) ? (
        <div>
          <Form.Label>Monthly Charges</Form.Label>

          <Table variant="sm" className={style.table}>
            <thead>
              <tr>
                <th className={style.colHead} />
                <th className={style.colTargetPrice}>Target price</th>
              </tr>
            </thead>
            <tbody>
              {props.flatMonthlyChargeModifiable ? (
                <tr>
                  <th>Flat Monthly Charge</th>
                  <td>
                    <InputGroup>
                      <InputGroup.Append>
                        <InputGroup.Text>$</InputGroup.Text>
                      </InputGroup.Append>
                      <FormControl
                        as={OnBlurInput}
                        type="number"
                        value={props.flatMonthlyCharge}
                        onConfirm={e =>
                          props.setFlatMonthlyCharge(e.target.value)
                        }
                        max={props.defaultFlatMonthlyCharge}
                      />
                    </InputGroup>
                  </td>
                </tr>
              ) : null}
              {IS_NZ &&
              props.minimumMonthlyChargeModifiable &&
              props.defaultMinimumMonthlyCharge ? (
                <tr>
                  <th>Minimum Monthly Charge</th>
                  <td>
                    <InputGroup>
                      <InputGroup.Append>
                        <InputGroup.Text>$</InputGroup.Text>
                      </InputGroup.Append>
                      <FormControl
                        as={OnBlurInput}
                        type="number"
                        value={props.minimumMonthlyCharge}
                        onConfirm={e =>
                          props.setMinimumMonthlyCharge(e.target.value)
                        }
                        max={props.defaultMinimumMonthlyCharge}
                      />
                    </InputGroup>
                  </td>
                </tr>
              ) : null}
              {IS_NZ && props.defaultNzScanningMonthlyCharge ? (
                <tr>
                  <th>Scanning Monthly Charge</th>
                  <td>
                    <InputGroup>
                      <InputGroup.Append>
                        <InputGroup.Text>$</InputGroup.Text>
                      </InputGroup.Append>
                      <FormControl
                        as={OnBlurInput}
                        type="number"
                        value={props.nzScanningMonthlyCharge}
                        onConfirm={e =>
                          props.setNzScanningMonthlyCharge(e.target.value)
                        }
                        max={props.defaultNzScanningMonthlyCharge}
                      />
                    </InputGroup>
                  </td>
                </tr>
              ) : null}
            </tbody>
          </Table>
        </div>
      ) : null}

      {IS_NZ &&
      (props.defaultPerA3Charge || props.defaultTonerDeliveryCharge) ? (
        <div>
          <Form.Label>Other Charges</Form.Label>

          <Table variant="sm" className={style.table}>
            <thead>
              <tr>
                <th className={style.colHead} />
                <th className={style.colTargetPrice}>Target price</th>
              </tr>
            </thead>
            <tbody>
              {props.defaultPerA3Charge !== null ? (
                <tr>
                  <th>Per A3 Charge</th>
                  <td>
                    <select
                      value={props.perA3Charge}
                      onChange={e => props.setPerA3Charge(e.target.value)}
                      style={{
                        width: "100%",
                        height: "38px",
                        border: "1px solid lightgray",
                        borderRadius: "4px"
                      }}
                    >
                      {props.defaultPerA3Charge.map(item => {
                        for (const [key, value] of Object.entries(item)) {
                          return (
                            <option key={key} value={key}>
                              {value}
                            </option>
                          );
                        }
                        return null;
                      })}
                    </select>
                  </td>
                </tr>
              ) : null}
              {props.defaultTonerDeliveryCharge !== null ? (
                <tr>
                  <th>Toner Delivery Charge</th>
                  <td>
                    <InputGroup>
                      <InputGroup.Append>
                        <InputGroup.Text>$</InputGroup.Text>
                      </InputGroup.Append>
                      <FormControl
                        as={OnBlurInput}
                        type="number"
                        value={props.tonerDeliveryCharge}
                        onConfirm={e =>
                          props.setTonerDeliveryCharge(Number(e.target.value))
                        }
                        max={props.defaultTonerDeliveryCharge}
                      />
                    </InputGroup>
                  </td>
                </tr>
              ) : null}
            </tbody>
          </Table>
        </div>
      ) : null}

      {props.scanningMonthlyCharge ? (
        <p>
          Includes {formatMoney(props.scanningMonthlyCharge)} scanning monthly
          charge
        </p>
      ) : null}

      {props.flatMonthlyCharge && !props.isPPPOrPMP &&
      props.flatMonthlyChargeModifiable === false ? (
        <p>
          Includes {formatMoney(props.flatMonthlyCharge)} flat monthly charge
        </p>
      ) : null}

      {props.minimumMonthlyCharge &&
      props.minimumMonthlyChargeModifiable === false ? (
        <p>
          Includes {formatMoney(props.minimumMonthlyCharge)} minimum monthly
          charge
        </p>
      ) : null}
    </div>
  );
}

export default connect(
  state => {
    const {
      ccBw,
      ccColour,
      scanCharge,

      defaultCcBw,
      defaultCcColour,
      hasFallbackCcBw,
      hasFallbackCcColour,
      defaultScanCharge,
      defaultPerA3Charge,
      defaultTonerDeliveryCharge,
      defaultFlatMonthlyCharge,
      defaultScanningMonthlyCharge,
      defaultNzScanningMonthlyCharge,
      defaultMinimumMonthlyCharge,

      scanningMonthlyCharge,
      nzScanningMonthlyCharge,
      flatMonthlyCharge,
      flatMonthlyChargeModifiable,
      perA3Charge,
      tonerDeliveryCharge,
      minimumMonthlyCharge,
      minimumMonthlyChargeModifiable
    } = state.product;

    return {
      isPPPOrPMP: isPPPOrPMP(state),
      ccBw,
      ccColour,
      scanCharge,

      defaultCcBw,
      defaultCcColour,
      hasFallbackCcBw,
      hasFallbackCcColour,
      defaultScanCharge,
      defaultPerA3Charge,
      defaultTonerDeliveryCharge,
      defaultFlatMonthlyCharge,
      defaultScanningMonthlyCharge,
      defaultNzScanningMonthlyCharge,
      defaultMinimumMonthlyCharge,

      scanningMonthlyCharge,
      nzScanningMonthlyCharge,
      flatMonthlyCharge,
      flatMonthlyChargeModifiable,
      perA3Charge,
      tonerDeliveryCharge,
      minimumMonthlyCharge,
      minimumMonthlyChargeModifiable
    };
  },
  {
    setCcBw,
    setCcColour,
    setScanCharge,
    setFlatMonthlyCharge,
    setPerA3Charge,
    setMinimumMonthlyCharge,
    setTonerDeliveryCharge,
    setNzScanningMonthlyCharge
  }
)(Charges);
